import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BasicModalCPProps, ModalCP } from 'submodules/nerit-framework-ui/common/components/modal/ModalCP'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { TextAreaCP } from 'submodules/nerit-framework-ui/common/components/form-fields/text-area/TextAreaCP'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { CollectionControlRequests } from 'submodules/nerit-aquatec-sdk/services/collection-control/CollectionControlRequests'
import { CollectionGridCellResponseDTO } from 'submodules/nerit-aquatec-sdk/services/collection-control/dtos/responses/CollectionGridResponseDTO'
import { CollectionCellFormModel } from 'modules/collection-performance/components/collection-control/modal-collection-cell/inner/CollectionCellFormModel'
import { CollectionStatusUtils } from 'modules/collection-performance/utils/CollectionStatusUtils'

interface ICPProps extends BasicModalCPProps {
    locationCode: number
    locationName: string
    monthLabel: string
    year: number
    month: number
    cell?: CollectionGridCellResponseDTO
}

/**
 * Modal de edicao de uma celula do Controle de Pontos (Tela 3.2).
 * Permite escolher um dos 5 status e uma nota, ou voltar ao status automatico.
 */
export function ModalCollectionCellCP(props: ICPProps): JSX.Element {

    const [formModel, setFormModel] = useState<CollectionCellFormModel>(new CollectionCellFormModel())
    const formStateManager = useFormStateManager(formModel)

    const saveRequest = useRequest<void>('none')
    useEffect(onSaveRequestChange, [saveRequest.isAwaiting])

    useEffect(init, [props.visible])

    /**
     */
    function init(): void {

        if (!props.visible) {
            setFormModel(new CollectionCellFormModel())
            return
        }

        setFormModel(new CollectionCellFormModel({
            status: props.cell?.status,
            note: props.cell?.note,
        }))
    }

    /**
     * Salva o estado completo desejado da celula.
     */
    function onClickSave(): void {

        const formValues = formStateManager.getFormValues()!
        saveRequest.runRequest(CollectionControlRequests.saveCell({
            locationCode: props.locationCode,
            year: props.year,
            month: props.month,
            status: formValues.status,
            note: formValues.note,
        }))
    }

    /**
     * Volta a celula ao status derivado automaticamente (remove o override).
     */
    function onClickResetToAutomatic(): void {

        saveRequest.runRequest(CollectionControlRequests.saveCell({
            locationCode: props.locationCode,
            year: props.year,
            month: props.month,
            status: null,
            note: '',
        }))
    }

    /**
     */
    function onSaveRequestChange(): void {

        if (!RequestUtils.isValidRequestReturn(saveRequest, NotificationHelper.DEFAULT_ERROR_SAVE_MESSAGE, NotificationHelper.DEFAULT_SUCCESS_SAVE_MESSAGE, true))
            return

        props.onSave()
    }

    return (
        <ModalCP
            visible={props.visible}
            actionLoading={saveRequest.isAwaiting}
            onOk={onClickSave}
            onCancel={props.onCancel}
            title={`${props.locationName} — ${props.monthLabel}`}
            width={460}
        >
            <SelectCP
                label={'Status'}
                required={true}
                options={CollectionStatusUtils.getSelectOptions()}
                formStateManager={formStateManager}
                fieldName={'status'}
            />

            <TextAreaCP
                label={'Observação'}
                formStateManager={formStateManager}
                fieldName={'note'}
                minRows={3}
            />

            <ResetWrapperSCP>
                <ButtonCP
                    type={'link'}
                    onClick={onClickResetToAutomatic}
                    loading={saveRequest.isAwaiting}
                >
                    {'Voltar ao status automático'}
                </ButtonCP>
            </ResetWrapperSCP>
        </ModalCP>
    )
}

const ResetWrapperSCP = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
`
